import { render, staticRenderFns } from "./payChannelSummary.vue?vue&type=template&id=e668d7e4&"
import script from "./payChannelSummary.vue?vue&type=script&lang=js&"
export * from "./payChannelSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports